import { translate } from "../../util/translate"

export const realtyHeaders = [
  {
    text: translate['realty.label.code'],
    value: 'code',
    width: 60,
  },
  {
    text: translate['realty.label.city'],
    value: 'city.name',
    width: '10vw',
  },
  {
    text: translate['realty.label.address'],
    value: 'address',
    width: '20vw',
  },
  {
    text: translate['realty.label.additionalAddressData'],
    value: 'additional_address_data',
    width: '10vw',
  },
  {
    text: translate['realty.label.privateAreaMetersShort'],
    value: 'private_area_meters',
    width: '5vw',
  },
  {
    text: translate['realty.label.squareMetersShort'],
    value: 'square_meters',
    width: '5vw',
  },
  {
    text: translate['realty.label.furniture'],
    value: 'furnished',
    width: '5vw',
    align: 'center'
  },
  {
    text: translate['realty.label.trousseau'],
    value: 'trousseau',
    width: '5vw',
    align: 'center'
  },
  { value: 'actions', align: 'center', width: 150 },
]
